export var SignalrConnectionHub;
(function (SignalrConnectionHub) {
    // cspell:disable-next-line
    SignalrConnectionHub["Crossdocking"] = "crossdockinghub";
    // cspell:disable-next-line
    SignalrConnectionHub["Location"] = "locationhub";
})(SignalrConnectionHub || (SignalrConnectionHub = {}));
